import { StyleSheet } from '@react-pdf/renderer'

export function usePDFStyleSheet(): Record<string, any> {
    return StyleSheet?.create({
        page: {
            flexDirection: 'column',
            backgroundColor: '#FFFFFF',
            padding: 30,
            fontFamily: 'Roboto',
        },
        header: {
            marginBottom: 20,
            borderBottom: '2 solid #333333',
            paddingBottom: 10,
        },
        headerContent: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        logo: {
            width: 80,
            height: 80,
            objectFit: 'contain',
        },
        clinicInfo: {
            flexDirection: 'column',
            alignItems: 'flex-end',
        },
        clinicName: {
            fontSize: 24,
            fontWeight: 'bold',
            color: '#333333',
        },
        clinicContact: {
            fontSize: 10,
            color: '#666666',
        },
        title: {
            fontSize: 28,
            fontWeight: 'bold',
            marginBottom: 10,
            color: '#333333',
            textAlign: 'center',
        },
        clientInfo: {
            marginBottom: 20,
            padding: 10,
            backgroundColor: '#F0F0F0',
            borderRadius: 5,
        },
        clientInfoTitle: {
            fontSize: 14,
            fontWeight: 'bold',
            marginBottom: 5,
            color: '#333333',
        },
        clientInfoText: {
            fontSize: 12,
            color: '#666666',
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1,
        },
        row: {
            flexDirection: 'row',
            marginBottom: 10,
        },
        column: {
            flex: 1,
            marginHorizontal: 5,
        },
        formElement: {
            marginBottom: 15,
        },
        label: {
            fontSize: 12,
            marginBottom: 5,
            color: '#666666',
        },
        input: {
            minHeight: 24,
            border: '1 solid #CCCCCC',
            borderRadius: 4,
            padding: 4,
        },
        inputText: {
            fontSize: 10,
            color: '#333333',
        },
        textarea: {
            minHeight: 80,
            border: '1 solid #CCCCCC',
            borderRadius: 4,
            padding: 4,
        },
        checkbox: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        checkboxBox: {
            width: 12,
            height: 12,
            border: '1 solid #CCCCCC',
            marginRight: 5,
            justifyContent: 'center',
            alignItems: 'center',
        },
        checkboxChecked: {
            width: 8,
            height: 8,
            backgroundColor: '#333333',
        },
        radioGroup: {
            flexDirection: 'column',
        },
        radio: {
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 5,
        },
        radioCircle: {
            width: 12,
            height: 12,
            borderRadius: 6,
            border: '1 solid #CCCCCC',
            marginRight: 5,
            justifyContent: 'center',
            alignItems: 'center',
        },
        radioChecked: {
            width: 6,
            height: 6,
            borderRadius: 3,
            backgroundColor: '#333333',
        },
        signature: {
            height: 100,
            border: '1 solid #CCCCCC',
            borderRadius: 4,
        },
        patientInfo: {
            marginTop: 10,
            padding: 10,
            backgroundColor: '#E6F3FF',
            borderRadius: 5,
        },
        patientInfoTitle: {
            fontSize: 14,
            fontWeight: 'bold',
            marginBottom: 5,
            color: '#333333',
        },
        patientInfoText: {
            fontSize: 12,
            color: '#666666',
        },
        clientPatientSection: {
            marginBottom: 15,
            padding: 10,
            backgroundColor: '#F0F0F0',
            borderRadius: 6,
            borderLeft: '3 solid #3498db',
        },
        sectionTitle: {
            fontSize: 12,
            fontWeight: 'bold',
            marginBottom: 5,
            color: '#2c3e50',
            textTransform: 'uppercase',
        },
        infoGrid: {
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        infoItem: {
            width: '33%',
            marginBottom: 4,
        },
        value: {
            fontSize: 9,
            color: '#34495e',
        },
        divider: {
            borderBottom: '1 solid #bdc3c7',
            marginVertical: 5,
        },
    })
}
